import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'


//import '@/assets/tailwind/tailwind.css'
// Required Core Stylesheet
 //import "@glidejs/glide/src/assets/sass/glide.core.scss";

// Optional Theme Stylesheet
//import "@glidejs/glide/src/assets/sass/glide.theme.scss";



import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.js'
import 'lightslider/dist/css/lightslider.css'



require('@/store/subscriber')

import '@/assets/styles_new.css'

// axios.defaults.baseURL = 'http://127.0.0.1:8000/api';
axios.defaults.baseURL = 'http://api.edu.umc-03.com/api';


Vue.config.productionTip = false

store.dispatch('auth/attempt', localStorage.getItem('token')).then(() => {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')    
})